import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onBeforeUnmount } from 'vue'

interface DashboardTemplate {
  id: number
  template_key: string
  name: string
  description: string
  icon: string
  visibility: 'all' | 'multi_group'
  widget_count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardTemplateDrawer',
  props: {
    show: { type: Boolean },
    templates: null,
    loading: { type: Boolean },
    listLoading: { type: Boolean }
  },
  emits: ["close", "create"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'create', payload: { templateId: number | null; name: string; description: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean
  templates: DashboardTemplate[]
  loading?: boolean
  listLoading?: boolean
}





const selected = ref<DashboardTemplate | null>(null)
const name = ref('')
const description = ref('')

function select(t: DashboardTemplate) {
  selected.value = t
  name.value = t.name
  description.value = t.description || ''
}

function onClose() {
  emit('close')
}

function selectBlank() {
  selected.value = null
  name.value = ''
  description.value = ''
}

function onCreate() {
  if (name.value.trim().length === 0) return
  emit('create', { templateId: selected.value ? selected.value.id : null, name: name.value.trim(), description: description.value })
}

function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape' && props.show) onClose()
}

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      selected.value = null
      name.value = ''
      description.value = ''
      document.addEventListener('keydown', onEscKey)
    } else {
      document.removeEventListener('keydown', onEscKey)
    }
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, selected, name, description, select, onClose, selectBlank, onCreate, onEscKey }
}

})